import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';

type Props = {
    label?: string;
    type: string;
    max?: number;
    min?: number;
    disabled: boolean;
    placeholder: string;
    noKey?: boolean
    id?: string
};

class FieldFileInput extends React.PureComponent<WrappedFieldProps & Props> {
    private fileInput: any;
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    public onChange(e) {
        const {
            input: { onChange }
        } = this.props;
        onChange(e.target.files[0]);
    }

    public render() {
        const {
            input,
            placeholder,
            noKey,
            id = 'fileInput',
            label,
            disabled
        } = this.props;
        let fileInputKey = input.value ? input.value.name : +new Date();
        fileInputKey = noKey ? undefined : fileInputKey

        return (
            <div className={`form-field__file-input${disabled ? ' form-field__file-input--disabled': ''}`}>
                {label && <label htmlFor={id} className="form-field__label">{label}</label>}
                <label htmlFor={id}>
                    <i className="icon--plus_sign" /> <span>{input.value ? input.value.name : placeholder}</span>
                </label>
                <div>
                    <input
                        id={id}
                        name={input.name ?? 'fileInput'}
                        disabled={disabled}
                        key={fileInputKey}
                        type="file"
                        accept=".jpg, .png, .jpeg"
                        onChange={event => input.onChange(event.target.files[0])}
                        ref={ref => (this.fileInput = ref)}
                    />
                </div>
            </div>
        );
    }
}

export default FieldFileInput;



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/FileField.tsx